// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/admin.scss
// module id = 34
// module chunks = 1